import Cookies from 'js-cookie';

const DEFAULT_DOMAIN = '.flow.qq.com';

export class Cookie {
  public domain = '';
  public expires = 1;
  constructor(domain: string, expires = 1) {
    this.domain = domain;
    this.expires = expires;
  }

  public get(key: string) {
    return Cookies.get(key);
  }

  public set(key: string, value: any, options?: Cookies.CookieAttributes) {
    Cookies.set(key, value, {
      domain: this.domain,
      expires: this.expires,
      ...options,
    });
  }

  public delete(key: string) {
    Cookies.remove(key, {
      domain: this.domain,
    });
  }
}

const cookie = new Cookie(DEFAULT_DOMAIN);

export default cookie;
